export default "//yastatic.net/s3/distribution/pythia/frontend/_/8b34c30959e9fdbcefef198fcf39daea.png";